<!-- <ion-header class="header-item">
  <ion-toolbar class="ion_tool_bar_css">
    <ion-buttons slot="start" class="mrglft5pt">
      <ion-icon name="arrow-back" class="icon_left" (click)="closeBtnClick({})"></ion-icon>
    </ion-buttons>
    <span class="headerText">Select user</span>
  </ion-toolbar>
</ion-header> -->
<app-app-header [showBackBtn]="showBackBtn" [title]="pageTitle" (click)="closeBtnClick({})"></app-app-header>


<ion-content [scrollY]="true" [fullscreen]="true" [style.margin-bottom.px]="keyboardHeight">
  <div>
    <!-- <div class="searchTitle">Search</div> -->
    <div class="searchbar-border">
      <ion-searchbar class="custom-searchbar" placeholder="Search" [formControl]="searchControl" id="searchText"
       (ionClear)="clearSearch()" (ionInput)="onSearchInput($event)" show-clear-button="always" ></ion-searchbar>
    </div>
  </div>

  <!-- Debug: Show search state -->
  <!-- <div style="padding: 10px; background: #f0f0f0; font-size: 12px;">
    Debug: searchTerm length={{ searchTerm.length }}, 
    searchUsersList length={{ searchUsersList.length }}, 
    fromAction={{ fromAction }}
  </div> -->

  <div class="pdlft10" *ngIf="searchTerm && searchTerm.length > 0 && searchUsersList.length == 0">
    <ion-row>
      <ion-col>
        <div>
          <span class="not_found_css">User not found!</span><br><br>
          <span class="notFoundText" *ngIf="fromAction != 'add-action'">If you cannot find the user in the list, please click the "Add User" button to add
            a new user.</span>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="fromAction != 'add-action'">
      <ion-col>
        <ion-button class="addContractor_btn_css" (click)="callAddContractor()">
          Add user
        </ion-button>
      </ion-col>
    </ion-row>
  </div>

  <!-- <div class="user-list" *ngIf="searchUsersList && searchUsersList.length > 0"> -->
    <!-- <div *ngFor="let item of searchUsersList" [ngClass]="{'disabled-user': fromAction == 'add-action' && !item?.person_unique_id}">
      <ion-row class="user-row" (click)="userSelected(item)">
        <ion-col class="user-info">
          <div class="profie-pic">
             <ion-icon *ngIf="!item?.profile_image" name="person-circle-outline" class="user-photo-icon"> </ion-icon>
            <img *ngIf="item?.profile_image" [src]="item?.profile_image" class="user-photo-img" />
          </div>
          <div class="profie-name">
            <div class="user-name">
              {{ item?.Full_Name || item?.full_name || ((item?.Fname || item?.first_name || item?.First_Name || '') + ' ' + (item?.Lname || item?.last_name || item?.Last_Name || '')).trim() || item?.Email }}
            </div>
            <div class="user-email" *ngIf="!(item?.email_hide)">
              {{ item?.Email || item?.email }}
            </div>
          </div>

          <div class="user-badge" [ngClass]="{
              employee: item?.relationEmployee,
              contractor: item?.relationEmployee
            }">
            {{ item?.relationEmployee ? "Employee" : "Contractor" }}
          </div>
        </ion-col>
      </ion-row>
    </div> -->

  <div class="users-list" *ngFor="let item of searchUsersList">
  
    <ion-row class="user-row" (click)="userSelected(item)" [ngClass]="{
         'disabled-user': fromAction === 'add-action' && !item?.person_unique_id
       }">
      <ion-col class="user-details">
  
        <div class="profie-pic-wrapper">
          <div class="profie-pic">
            <ion-icon *ngIf="!item?.profile_image" name="person-circle-outline" class="user-photo-icon"></ion-icon>
        
            <img *ngIf="item?.profile_image" [src]="item?.profile_image" class="user-photo-img" />
          </div>
          <div class="profie-pic-overlay" *ngIf="fromAction === 'add-action' && item?.person_unique_id">
            <ion-icon src="assets/img/SHIELD/bog-icon-new.svg" class="shield-icon">
            </ion-icon>
          </div>
        </div>
  
        <div class="profie-name">
  
          <div class="user-name">
            {{
            item?.Full_Name ||
            item?.full_name ||
            (
            (item?.Fname || item?.first_name || item?.First_Name || '') + ' ' +
            (item?.Lname || item?.last_name || item?.Last_Name || '')
            ).trim() ||
            item?.Email
            }}
          </div>
  
          <div class="user-email" *ngIf="!item?.email_hide">
            {{ item?.Email || item?.email }}
          </div>
  
          <div class="user-badge" [ngClass]="{
                 'employee': item?.relationEmployee === true,
                 'contractor': item?.relationEmployee !== true
               }">
            {{ item?.relationEmployee ? "Employee" : "Contractor" }}
          </div>
  
        </div>
      </ion-col>
  
      <!-- <ion-col class="select-col" size="auto" *ngIf="fromAction === 'add-action' && item?.person_unique_id">
        <button class="select-btn">Select</button>
      </ion-col> -->

      <ion-col class="select-col" size="auto"
        *ngIf="(fromAction === 'add-action' && item?.person_unique_id) || (fromAction === 'add-discussed-user')">
        <button class="select-btn" [ngClass]="{'selected-user': item?.selected}">{{item?.btnText}}</button>
      </ion-col>
  
    </ion-row>
  </div>

  <!-- </div> -->
</ion-content>